module.exports = __webpack_public_path__ + "static/media/test10_4.01500943.png";